import { useState, useEffect } from 'react';

const CssLoader = ({ cssLink }) => {
	const [cssTag, setCssTag] = useState(null);

	useEffect(() => {
		const newCssTag = cssTag ?? document.createElement('link');
		newCssTag.href = cssLink;
		newCssTag.setAttribute('rel', 'stylesheet');
		newCssTag.setAttribute('type', 'text/css');
		setCssTag(newCssTag);
		document.head.appendChild(newCssTag);
	}, [cssLink]);

	return null;
};

export default CssLoader;